import { RequestTagType } from 'modules/request'
import {
  DocumentsContainer,
  DocumentsList,
  useProjectUuid,
  useDocumentsTabs,
  useDocumentsFilter,
  useDrawdownsTabs,
  useAMLTabs,
  useGetDocuments,
  getDocumentsCategoryTabs,
} from '..'

interface DocumentsProposalProps {
  isRequest?: boolean
  tag?: RequestTagType
}

export default function DocumentsProposal({isRequest, tag}: DocumentsProposalProps) {
  const projectUuid = useProjectUuid(isRequest, tag)
  const {data: documents} = useGetDocuments(projectUuid)
  const tabs = getDocumentsCategoryTabs(categoryKey, documents)
  const [activeTab, setActiveTab] = useDocumentsTabs(tabs)
  const {filteredDocuments, search, sort, setSearch, setSort} =
    useDocumentsFilter(documents, activeTab.collection)
  const {amlTabs} = useAMLTabs(projectUuid)
  const {drawdownsTabs} = useDrawdownsTabs(documents, isRequest)

  return (
    <DocumentsContainer
      categoryKey={categoryKey}
      tabs={tabs}
      activeTab={activeTab}
      modelUuid={projectUuid}
      modelType="project"
      search={search}
      sort={sort}
      setSearch={setSearch}
      setSort={setSort}
      setActiveTab={setActiveTab}
    >
      <DocumentsList
        projectUuid={projectUuid}
        modelUuid={projectUuid}
        modelType="project"
        collection={activeTab.collection}
        search={search}
        documents={filteredDocuments}
        drawdownsTabs={drawdownsTabs}
        amlTabs={amlTabs}
      />
    </DocumentsContainer>
  )
}

const categoryKey = 'proposal'
